import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import { Badge } from 'flowbite-react';
import React, { useState } from 'react';
import { Link, useLoaderData, useNavigate } from 'react-router-dom';

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Color',
    dataIndex: 'color',
    key: 'color',
    className: `whitespace-nowrap font-medium dark:text-white`,
    render: (_, record) => <div className={`rounded-full text-center`} style={{backgroundColor: record.color, color: record.color, width: '22px'}}>.</div>
  },
  {
    title: 'Active',
    dataIndex: 'active',
    key: 'active',
    className: 'whitespace-nowrap font-medium dark:text-white',
    render: (_, record) => <Badge className={record.active ? "text-green-950 bg-green-100 w-max" : "text-red-950 bg-red-100 w-max"}>{record.active ? 'active' : 'inactive'}</Badge>
  },
]



const ProductTags = () => {
  const productTags = useLoaderData();
  const navigate = useNavigate();

  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/inventory/product-tags/'+record.seo)
    };
  }

  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Product Tags</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/inventory/product-tags/new'} className='w-full'>New</Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <Table
        sticky
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={productTags}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
        rowKey={'number'}
      />
    
    </div>
  )
}

export default ProductTags;